// File: frontend/src/pages/StudentMaterialsPage.jsx

import React, { useState, useEffect } from 'react';
import { studentPortalAPI } from '../services/api';
import Spinner from '../components/Spinner';
import toast from 'react-hot-toast';

const isImageUrl = (url) => /\.(jpe?g|png|gif|webp|bmp)(\?|$)/i.test(url || '');
const isPdfUrl = (url) => /\.pdf(\?|$)/i.test(url || '');

export default function StudentMaterialsPage() {
    const [materials, setMaterials] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        studentPortalAPI.getMyMaterials()
            .then(setMaterials)
            .catch(() => toast.error("Could not load class materials."))
            .finally(() => setIsLoading(false));
    }, []);

    if (isLoading) return <Spinner />;

    return (
        <div>
            <h2 className="text-2xl font-bold mb-4">My Class Materials</h2>
            <div className="space-y-4">
                {materials.length > 0 ? materials.map(mat => {
                    const link = mat.file_url || mat.url;
                    const isImage = isImageUrl(link);
                    const isPdf = isPdfUrl(link);
                    return (
                        <div key={mat.id} className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow border border-gray-200 dark:border-gray-700">
                            <p className="text-xs text-gray-500 dark:text-gray-400">{mat.class_name}</p>
                            <a
                                href={link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="font-bold text-lg text-blue-600 hover:underline flex items-center gap-1.5"
                            >
                                <span>{isImage ? '🖼️' : isPdf ? '📄' : '🔗'}</span>
                                {mat.title}
                            </a>

                            {mat.description && (
                                <p className="text-sm text-gray-800 dark:text-gray-200 mt-2 bg-amber-50 border border-amber-200 rounded-lg p-2.5 whitespace-pre-wrap">
                                    💡 {mat.description}
                                </p>
                            )}

                            {isImage && (
                                <a href={link} target="_blank" rel="noopener noreferrer" className="block mt-3">
                                    <img
                                        src={link}
                                        alt={mat.title}
                                        className="max-h-64 rounded-lg border border-gray-200 dark:border-gray-700 object-contain"
                                    />
                                </a>
                            )}

                            {isPdf && (
                                <a
                                    href={link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-1.5 mt-3 px-3 py-1.5 bg-red-50 hover:bg-red-100 text-red-700 text-sm font-semibold rounded-lg border border-red-200"
                                >
                                    📄 Open PDF
                                </a>
                            )}
                        </div>
                    );
                }) : <p className="text-gray-500 dark:text-gray-400">No materials have been added to your classes yet.</p>}
            </div>
        </div>
    );
}
